/**
 * Constants ported 1:1 from the iOS PDF feature.
 * iOS sources of truth:
 * - Sources/Application/SwiftUI/Works/PDF/WorkPDFGenerator.swift
 * - Sources/Application/Screens/Works/WorkActions/WorkActions.swift (HardcodedPDFBackCover)
 */

// A4 in PDF points (matches iOS `pageWidth` / `pageHeight`)
export const pageWidth = 595.2
export const pageHeight = 841.8
export const defaultMargin = 10

export const pdfCreator = "Views"
export const pdfAuthor = "Views"

export const poweredByUrl = "https://views.art/?utm_campaign=powered-by-footer&utm_source=works-pdf&utm_medium=pdf"

// Hardcoded back covers (iOS: HardcodedPDFBackCover)
const whiteCubeBackCoverUrl =
	"https://views-public-resources-production-default.s3.eu-west-1.amazonaws.com/teams/whitecube/white-cube-back-cover-2026-v2.pdf"

export const redPandaOrgId = "0x362aee"

export const hardcodedBackCovers: Record<string, string> = {
	[redPandaOrgId]: whiteCubeBackCoverUrl,
}

// Thumbnail cell size on the customise screen (iOS: 70x100 pt previews)
export const thumbWidth = 70
export const thumbHeight = 100

// iOS re-encodes images as JPEG "medium" quality
export const jpegQuality = 0.85

// Debounce for text-input driven thumbnail refresh (iOS: 0.5s polling timer)
export const previewRefreshMs = 500

/**
 * pdf-lib's origin is bottom-left; all iOS constants are top-down.
 * topY converts "y from top of page" + element height into a pdf-lib y.
 */
export function topY(yFromTop: number, elementHeight = 0, fromPageHeight = pageHeight): number {
	return fromPageHeight - yFromTop - elementHeight
}
